<div *ngIf="errorMessage" 
     id="warning-modal"
     class="flex items-center fixed left-2 top-2 w-80 z-[9999] shadow-lg text-sm rounded-lg py-4 px-5 cursor-pointer transition-all duration-500 ease-out"
     
     [style.background-color]="isSuccess ? '#E6E1F0' : '#fee2e2'"

     [class.border-westetics-purple-800]="isSuccess"
     [class.text-westetics-purple-800]="isSuccess"
     [class.border]="true"
     [class.border-red-300]="!isSuccess"
     [class.text-red-800]="!isSuccess" 
     [class.opacity-100]="animationState === 'enter'"
     [class.translate-x-0]="animationState === 'enter'" 
     [class.opacity-0]="animationState === 'leave'"
     [class.-translate-x-full]="animationState === 'leave'" 
     role="alert" 
     (click)="dismiss()">

     <fa-icon [ngClass]="isSuccess ? 'text-westetics-purple-800' : 'text-red-600'"
        [icon]="isSuccess ? faCircleCheck : faCircleXmark" size="lg"></fa-icon>
     <div class="flex flex-col ml-3 min-w-0">
        <span [ngClass]="isSuccess ? 'text-westetics-purple-800' : 'text-red-700'" class="text-sm font-medium leading-4 break-words">
            {{ errorMessage }}
        </span>
        <span *ngIf="!isSuccess" class="text-red-600 text-sm font-semibold leading-4">Tente novamente.</span>
        <span *ngIf="isSuccess" class="text-westetics-purple-800 text-sm font-semibold leading-4">Tudo certo!</span>
     </div>
</div>